import InputBox from "../../../components/InputBox/InputBox";
import useInputState from "../hooks/useInputState";
import erody from "../../../assets/erody_wink_body.svg";
import { useEffect, useState } from "react";

const ChatBotSelect = () => {
  const [
    brandId,
    phoneNumber,
    storeList,
    selectedStore,
    handlePhoneNumberChange,
    handleChange,
    handleBranchChange,
    fetchUrl,
  ] = useInputState();

  const [color, setColor] = useState("yellow-c-emart");
  const requiresBranchSelection = !["NB", "ED"].includes(brandId);

  useEffect(() => {
    switch (brandId) {
      case "EM":
        setColor("yellow-c-emart");

        break;
      case "TR":
        setColor("green-c-traders");

        break;
      case "NB":
        setColor("yellow-c-nobrand");

        break;
      case "ED":
        setColor("yellow-c-everyday");

        break;
      default:
        setColor("yellow-c-emart");
    }
  }, [brandId]);

  return (
    <form className="w-full p-4">
      <div className="flex flex-col gap-4">
        <h1 className="py-4 text-2xl font-semibold text-center text-neutral-950">
          이로디 디지털상담 ver2.0
        </h1>
        <select
          value={brandId}
          onChange={(e) => handleChange(e.target.value)}
          className={`h-12 px-4 py-2 bg-transparent rounded-md focus:outline-none select border-${color}`}
        >
          <option value="EM">이마트</option>
          <option value="TR">트레이더스</option>
          <option value="NB">노브랜드</option>
          <option value="ED">에브리데이</option>
        </select>
        {
          requiresBranchSelection && (
          <select
            value={selectedStore}
            onChange={(e) => handleBranchChange(e.target.value)}
            className={`h-12 px-4 py-2 bg-transparent rounded-md focus:outline-none select border-${color}`}
          >
            {storeList.map((store) => {
              return (
                <option key={store.id} value={store.storeId}>
                  {store.name}
                </option>
              );
            })}
          </select>
          )
        }
        <InputBox
          keyword={phoneNumber}
          handleInputChange={(e) => handlePhoneNumberChange(e.target.value)}
          handleClearClick={(e) => {
            e.preventDefault();
            handlePhoneNumberChange("");
          }}
          placeholder="전화번호를 입력하세요"
        ></InputBox>
        <button
          className={`text-lg h-20 px-4 py-2 font-bold text-black rounded-md bg-${color} hover:bg-opacity-80`}
          onClick={(e) => {
            fetchUrl(e);
          }}
        >
          디지털상담 시작하기
        </button>
        <div className="flex justify-center py-10">
          <img src={erody} alt="이로디캐릭터" className="w-3/5" />
        </div>
      </div>
    </form>
  );
};

export default ChatBotSelect;
